import LocalStorage from './localStorage';

export const getLoggedInUser = () => {
  const loginUser = LocalStorage.getItem('Gravity_user') || '';
  const user = loginUser || { user: null };
  // session_token is required — old sessions (pre-concurrent-session-control) are treated as logged out
  const loggedIn = loginUser !== '' && !!loginUser?.session_token;
  return {
    ...user,
    loggedIn
  };
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const blobToFile = (blob, fileName) => {
  blob.lastModified = new Date().getTime();
  blob.name = fileName;

  return blob;
};

// Formats a batch number with its dispense process › sub process, e.g.
// "CBPA126001 (Compression › Inspection)". Returns the plain batch number when
// no process is present so Stage-1 batches stay clean. Display-only — never
// store the composed string (it would break batch-number matching downstream).
export const formatBatchWithProcess = (
  batchNumber,
  processName,
  subProcessName
) => {
  const base = batchNumber || '';
  if (!processName && !subProcessName) return base;
  const process = processName || 'NA';
  const subProcess = subProcessName ? ` › ${subProcessName}` : '';
  return `${base} (${process}${subProcess})`;
};

export const removeDuplicatesFromArray = (arr, key) => {
  const uniqueArr = [];

  const unique = arr.filter((item) => {
    const isDuplicate = uniqueArr.includes(item[`${key}`]);

    if (!isDuplicate) {
      uniqueArr.push(item[`${key}`]);

      return true;
    }

    return false;
  });

  return unique;
};

export function numFormating(value) {
  var val = Math.abs(value);
  if (val >= 10000000) {
    val = (val / 10000000).toFixed(0) + 'Cr';
  } else if (val >= 100000) {
    val = (val / 100000).toFixed(0) + 'Lac';
  } else if (val >= 1000) {
    val = Math.abs(val)?.toLocaleString(undefined, {
      maximumFractionDigits: 2
    });
  }
  return val;
}

export const weighingRules = (ruleID, no_of_cont, weighing_cont) => {
  if (ruleID == 1) {
    if (weighing_cont == no_of_cont) {
      return true;
    }
  }
  if (ruleID == 2) {
    if (no_of_cont <= 5) {
      if (weighing_cont == no_of_cont) {
        return true;
      }
    }
    if (no_of_cont > 5 && no_of_cont <= 25) {
      if (weighing_cont == 6) {
        return true;
      }
    }
    if (no_of_cont > 25) {
      if (weighing_cont == Math.round(Math.sqrt(no_of_cont)) + 1) {
        console.log(Math.round(Math.sqrt(no_of_cont)));
        return true;
      }
    }
  }
  if (ruleID == 3) {
    if (weighing_cont >= 0) {
      return true;
    }
  }
};

export const weighingRulesCount = (ruleID, no_of_cont) => {
  if (ruleID == 1) {
    return no_of_cont;
  }
  if (ruleID == 2) {
    if (no_of_cont <= 5) {
      return no_of_cont;
    }
    if (no_of_cont > 5 && no_of_cont <= 25) {
      return 6;
    }
    if (no_of_cont > 25) {
      return Math.round(Math.sqrt(no_of_cont) + 1);
    }
  }
  if (ruleID == 3) {
    return 0;
  }
};

export const roles = (role, level) => {
  if (role == 'user' && level !== 3) {
    return 'Warehouse User';
  } else if (role == 'user' && level == 3) {
    return 'Warehouse Lead';
  }
  if (role == 'qc_initiator' && level !== 3) {
    return 'QA User';
  } else if (role == 'qc_initiator' && level == 3) {
    return 'QA Lead';
  }
  if ((role == 'qa-initiator' || role == 'qa_initiator') && level !== 3) {
    return 'QC User';
  } else if (role == 'qa_initiator' && level == 3) {
    return 'QC Lead';
  }
  if (role == 'prod_user' && level !== 3) {
    return 'Production User';
  } else if (role == 'prod_user' && level == 3) {
    return 'Production Lead';
  }
  if (role == 'admin') {
    return 'Admin';
  }
  if (role == 'ppic_user') {
    return 'PPIC User';
  }
};

// Roles that raise material-code dispensing requests ("material indents"):
// QC (qa_initiator) any level, Production-eBMR level 3, Warehouse level 2.
// They get the Create button on /dispense-material-list and a create form fixed
// to material code — the Request Type radio is hidden and the type is forced in
// onFinish. Kept in one place so the next role granted this is a single edit
// rather than another sweep through the dispensing list and form.
export const canRaiseMaterialIndent = (user) =>
  user?.role === 'qa_initiator' ||
  (user?.role === 'prod_ebmr' && user?.level === 3) ||
  (user?.role === 'user' && user?.level === 2);

// Of those, the roles whose ONLY business with dispensing requests is raising
// material indents — their list is narrowed to type=material.
//
// Warehouse is deliberately excluded. /dispense-material-list is also its
// dispensing execution queue: ~19,000 of the ~20,800 requests on it are BMR
// based, and the Product Batch column is how warehouse reaches manual dispense.
// Narrowing it would also disable their search, because list_view returns from
// the type=material branch before the search filter is applied.
export const isMaterialIndentOnlyRole = (user) =>
  user?.role === 'qa_initiator' ||
  (user?.role === 'prod_ebmr' && user?.level === 3);

export const getRoles = (role) => {
  const loginUser = LocalStorage.getItem('Gravity_user') || '';
  const user = loginUser || { user: null };
  const Superadmindata = user?.user?.qa_super_level.filter(
    (item) => item?.department == role
  );
  return {
    Superadmindata
  };
};
